import { getLink } from '../../../utils/utils';

import author from './author';
const content = {
  esp: (
    `
    <div class="poem">

      <p class="mb-3 bold text-center">* * *</p>

      <p class="poem-block mb-3">
        Ni similas al alia raso: <br/>
        Steloj ne por ni briletas sore, <br/>
        Ne por ni brakume, kor-al-kore, <br/>
        Trinkas paroj el kristala glaso.
      </p>

      <p class="poem-block mb-3">
        Ruĝa tuko ne por ni sterniĝas <br/>
        Sur la griza lito de tenero, <br/>
        Kaj sur glata spaco de aero <br/>
        Lante kaj senĉese ni moviĝas. 
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Ni similas al alia raso'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;